import * as account from './store/reducers/account.reducer';
import * as organization from './store/reducers/account-organization.reducer';
import * as adOrderDraft from './store/reducers/ad-order-draft.reducer';
import * as accountNotifications from './store/reducers/notifications.reducer';
import * as statistics from './store/reducers/statistics.reducer';
import * as myPlatforms from './store/reducers/my-platforms.reducer';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';

export interface AppState  {
  account: account.AccountState,
  organization: organization.AccountOrganizationState,
  adOrderDraft: adOrderDraft.AdOrderDraftState,
  accountNotifications: accountNotifications.AccountNotificationsState;
  router: RouterReducerState<any>;
  statistics: statistics.StatisticsState;
  myPlatforms: myPlatforms.MyPlatformsState;
}

export const appReducers: ActionReducerMap<AppState> = {
  account: account.accountReducer,
  organization: organization.accountOrganizationReducer,
  adOrderDraft: adOrderDraft.adOrderDraftReducer,
  accountNotifications: accountNotifications.accountNotificationsReducer,
  router: routerReducer,
  statistics: statistics.statisticsReducer,
  myPlatforms: myPlatforms.myPlatformsReducer,
};
